import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  :host {
    display: none;
    background-color: var(--com-calendar-drawer-background, var(--primary-active));
  }

  :host([open]) {
    display: block;
  }

  /* Animation Styling Begin */

  @keyframes com-calendar-drawer-fade-in {
    0% {
      transform: scale(1);
      opacity: 0;
    }
    15% {
      transform: scale(1.01);
      opacity: 0.5;
    }
    33% {
      transform: scale(1.02);
      opacity: 1;
    }
    66% {
      transform: scale(0.99);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes com-calendar-drawer-push {
    0% {
      transform: scale(1);
    }
    33% {
      transform: scale(1.02);
    }
    66% {
      transform: scale(0.99);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes com-calendar-drawer-ease-in {
    0% {
      color: var(--com-calendar-drawer-background, var(--primary-active));
    }
    33% {
      color: var(--com-calendar-drawer-background, var(--primary-active));
    }
    66% {
      color: var(--com-calendar-drawer-color, white);
    }
    100% {
      color: var(--com-calendar-drawer-color, white);
    }
  }

  :host([animate][fade-in]) {
    animation: com-calendar-drawer-fade-in .4s ease;
  }

  :host([animate]:not([fade-in])) {
    animation: com-calendar-drawer-push .4s ease;
  }

  #drawerContent {
    color: white;
  }

  :host([enable]) #drawerContent {
    margin-top: 24px;
  }

  :host([enable]) #drawerContent:after {
    content: "";
    position: absolute;
    right: 46%;
    top: -19px;
    border-top: none;
    border-right: 18px solid transparent;
    border-left: 18px solid transparent;
    border-bottom: 19px solid var(--com-calendar-drawer-background, var(--primary-active));
  }

  :host([animate]) #drawerContent {
    animation: com-calendar-drawer-ease-in .4s ease;
  }
</style>
</template>`;

styleElement.register('com-calendar-drawer-style');